/**
 * Takes a background colour as hex and returns whether the text should be light or dark.
 *
 * @param {string} colour The background colour (hex).
 * @returns {string} Returns 'light' or 'dark'.
 * @example
 *
 * textColourForBackground('#FFFFFF');
 * // -> 'dark'
 *
 * textColourForBackground('#000000');
 * // -> 'light'
 */
export function textColourForBackground(colour: string): 'dark' | 'light' {
  const colourAsRgb = +('0x' + colour?.slice(1).replace(colour.length < 5 ? /./g : '', '$&$&'));

  const r = colourAsRgb >> 16;
  const g = (colourAsRgb >> 8) & 255;
  const b = colourAsRgb & 255;

  const brightness = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  if (brightness > 127.5) {
    // Background colour is light, text should be dark.
    return 'dark';
  } else {
    // Background colour is dark, text should be light.
    return 'light';
  }
}
